<template>
  <b-container style="padding:5px!important;">
    <dx-popup
      :visible="true"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :title="title"
      :show-title="false"
      :show-close-button="false"
      :max-height="550"
      :max-width="575"
    >
      <form @submit.prevent="onFormSubmit">
        <b-container fluid>
          <b-row>
            <b-col>
              <div
                class="d-flex justify-content-center"
                style="background-color:#000000"
              >
                <b-img class="p-2" :src="LinkLogo" fluid style="padding:5px;" />
              </div>
            </b-col>
          </b-row>
          <br />
          <b-row v-if="!isLoading">
            <b-col>
              <div>
                <h5 class="text-center">Please sign in</h5>
              </div>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col>
              <div class="d-flex m-1 justify-content-center">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </b-col>
          </b-row>
          <br />
          <b-row class="m-1 p-2">
            <b-col>
              <dx-form
                col-count="1"
                :form-data="credentials"
                :items="fieldConfig"
                :disabled.sync="isLoading"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex justify-content-sm-center">
              <b-link to="forgot">Forgot password</b-link>
            </b-col>
          </b-row>
          <b-row class="comp-footer">
            <b-col>
              <b-row class="mt-3 mb-2">
                <!-- <b-col class="d-flex text-middle text-center">
              <span class="ml-4 fine-print">
                &copy; 2020 LINK Document Services Group LLC. All rights
                reserved.
              </span>
            </b-col> -->
              </b-row>
              <b-row class="mt-1 mb-2">
                <b-col class="d-flex text-middle text-center">
                  <span class="ml-4 fine-print">
                    &copy; 2020 LINK Document Services Group LLC. All rights
                    reserved.
                  </span>
                </b-col>
                <b-col
                  :cols="4"
                  class="d-flex justify-content-sm-end fine-print"
                >
                  <b-link
                    href="http://www.linkdsg.com/terms-of-use"
                    target="_blank"
                  >
                    Terms of Use
                  </b-link>
                  <i class="ml-1 mr-1">|</i>
                  <b-link
                    href="http://www.linkdsg.com/privacy-policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </b-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </form>
    </dx-popup>
  </b-container>
</template>

<script>
// import { DxPopup } from "devextreme-vue/popup";
// import { DxForm } from "devextreme-vue/form";
// import { mapActions, mapGetters } from "vuex";
import notify from "devextreme/ui/notify";

import BeLogo from "@/assets/brand/logo.png";
import LinkLogo from "@/assets/brand/logo2.png";

export default {
  // components: {
  //   DxPopup,
  //   DxForm
  // },
  data() {
    return {
      credentials: {
        userName: null,
        password: null,
        rememberMe: false
      },
      BeLogo,
      LinkLogo,
      fieldConfig: [
        {
          itemType: "dxItem",
          dataField: "userName",
          editorType: "dxTextBox",
          isRequired: true,
          mode: "email",
          label: {
            visible: false
          },
          editorOptions: {
            placeholder: "User Name (email)"
          }
        },
        {
          itemType: "dxItem",
          dataField: "password",
          editorType: "dxTextBox",
          isRequired: true,
          label: {
            visible: false
          },
          editorOptions: {
            mode: "pwd",
            placeholder: "Password",
            mode: "password"
          }
        },
        {
          itemType: "checkBox",
          dataField: "rememberMe"
        },
        {
          itemType: "group",
          colCount: 1,
          items: [
            {
              itemType: "empty"
            },
            {
              itemType: "button",
              horizontalAlignment: "center",
              buttonOptions: {
                text: "Sign In",
                width: 350,
                elementAttr: {
                  style: "background-color:#819DB3;color:#fff;font-weight:bold;"
                },
                type: "default",
                useSubmitBehavior: true
              }
            },
            {
              itemType: "button",
              horizontalAlignment: "center",
              buttonOptions: {
                width: 350,
                elementAttr: {
                  style: "background-color:#e85424;color:#fff;font-weight:bold;"
                },
                text: "Cancel",
                type: "danger",
                onClick: this.onCancelClick
              }
            }
          ]
        }
      ],
      title: "eConnect Login...",
      msg: ""
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["user/isAuthenticated"];
    },
    isLoading() {
      return this.$store.getters["isLoading"];
    }
  },
  // watch: {
  //   $route(to, from, next) {
  //     debugger;
  //     if (store.getters.isAuthenticated) {
  //       next();
  //       return;
  //     }
  //     next("/");
  //   }
  // },
  methods: {
    login() {
      return this.$store.dispatch("user/login", this.credentials);
    },
    onCancelClick(e) {
      debugger;
      window.location.href = "http://linkdsg.com";
    },
    onFormSubmit(e) {
      e.preventDefault;

      debugger;
      this.login(this.credentials).then(response => {
        if (this.isAuthenticated) {
          debugger;
          this.$router.push("/admin");
        }
      });

      return;
    }
  }
};
</script>

<style>
dx-popup.dx-popup-title {
  background-color: blue !important;
}
:root {
  --foot-display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue